import {
  Pipe,
  PipeTransform,
  NgZone,
  ChangeDetectorRef,
  OnDestroy
} from '@angular/core';
import { DatePipe } from '@angular/common';

@Pipe({
  name: 'timeAgo',
  pure: false
})
export class TimeAgoPipe implements PipeTransform, OnDestroy {
  private timer: number;

  constructor(
    private changeDetectorRef: ChangeDetectorRef,
    private ngZone: NgZone
  ) {}

  transform(value: string) {
    this.removeTimer();
    let datePipe = new DatePipe('en-US');
    let d = new Date(value);
    let now = new Date();
    let seconds = Math.round(Math.abs((now.getTime() - d.getTime()) / 1000));
    let timeToUpdate = this.getSecondsUntilUpdate(seconds) * 1000;

    this.timer = this.ngZone.runOutsideAngular(() => {
      if (typeof window !== 'undefined') {
        return window.setTimeout(() => {
          this.ngZone.run(() => this.changeDetectorRef.markForCheck());
        }, timeToUpdate);
      }
      return null;
    });

    // time format
    let minutes = Math.round(Math.abs(seconds / 60));
    let hours = Math.round(Math.abs(minutes / 60));
    let days = Math.round(Math.abs(hours / 24));

    if (seconds <= 59) {
      // until 59 seconds, will return Just Now
      return 'Just now';
    } else if (minutes <= 59) {
      // 1-59 minutes, will return "(number) min", example 21 min
      return minutes + 'min';
    } else if (hours <= 23) {
      // 1-23 hrs, will return "(number) h", example: 22 h
      return hours + 'h';
    } else if (hours <= 47) {
      // 24-47 hrs, will return Yesterday
      return 'Yesterday';
    } else {
      // after 8 days, will return date it last modified
      if (now.getUTCFullYear() === d.getUTCFullYear()) {
        // if still in the same year, show only date and month
        return datePipe.transform(value, 'dd MMM');
      } else {
        // else return full date
        return datePipe.transform(value, 'dd MMM yyyy');
      }
    }
  }
  ngOnDestroy(): void {
    this.removeTimer();
  }
  private removeTimer() {
    if (this.timer) {
      window.clearTimeout(this.timer);
      this.timer = null;
    }
  }
  private getSecondsUntilUpdate(seconds: number) {
    let min = 60;
    let hr = min * 60;
    let day = hr * 24;
    let week = day * 7;
    if (seconds < min) {
      // less than 1 min, update ever 2 secs
      return 2;
    } else if (seconds < hr) {
      // less than an hour, update every 30 secs
      return 30;
    } else if (seconds < day) {
      // less then a day, update every 5 mins
      return 300;
    } else if (seconds < week) {
      // less than a week, update every hour
      return 3600;
    }
    // after a week do not update
  }
}



// WEBPACK FOOTER //
// D:/Work-Local/frontend/src/app/_shared/pipes/time-ago.pipe.ts